import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=74196b18"
import script from "./EmployeeEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports